// extracted by mini-css-extract-plugin
export default {"table":"HealthView_table__qByZ4","heading":"HealthView_heading__3bbuS","compactViewButton":"HealthView_compactViewButton__2mjL0"};